import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TToggleOrderStatusRequestSchema,
  TToggleOrderStatusResponseSchema,
} from "./toggleOrderStatus.schema";

export const toggleOrderStatus = (axios: IAxiosInstance) => {
  return async (data: TToggleOrderStatusRequestSchema) => {
    const response = await axios.noRetry.post<
      IApiResponse<TToggleOrderStatusResponseSchema>
    >(`/api/orders/toggle-status`, data);

    return response.data;
  };
};
